import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatDistanceToNow } from "date-fns";
import { toast } from "react-toastify";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button } from "@mui/material";
import OrderItemEdit from "./OrderItemEdit";

function OrderConfirm({ orders, setOrders }) {
  const navigate = useNavigate();
  const [editingItem, setEditingItem] = useState(null);
  const API_BASE_URL = process.env.REACT_APP_BASE_URL;

  // Handle editing of an item
  const handleEditItem = (item) => {
    setEditingItem(item);
  };

  // Delete order item and possibly update order status
  const deleteOrderItem = (itemId, orderId) => {
    const apiUrl = `${API_BASE_URL}/orders/change_order_item_and_invoice_item_status/${itemId}`;

    fetch(apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "Success") {
          toast.success("Item cancelled successfully!");

          // Update frontend orders state
          const updatedOrders = orders.map((order) => {
            if (order.id === orderId) {
              const updatedItems = order.order_items.filter(
                (item) => item.id !== itemId
              );
              return { ...order, order_items: updatedItems };
            }
            return order;
          });

          setOrders(updatedOrders);

          // Check if current order is empty now
          const orderAfterUpdate = updatedOrders.find(
            (order) => order.id === orderId
          );
          const remainingItems = orderAfterUpdate?.order_items || [];

          if (remainingItems.length === 0) {
            setTimeout(() => {
              toast.info("All items cancelled. Redirecting to Take Order...");
            }, 2000);

            setTimeout(() => navigate("/take_order"), 3000);
          }
        } else {
          toast.error("Failed to cancel the item!");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        toast.error("An error occurred.");
      });
  };

  return (
    <div className="OrderConfirmContainer">
      <h2>Order Items List</h2>
      <table>
        <thead>
          <tr>
            <th>#</th>
            <th>Item Name</th>
            <th>Quantity</th>
            <th>Order Time</th>
            <th className="Actionsss">Action</th>
          </tr>
        </thead>
        <tbody>
          {orders.length === 0 ? (
            <tr>
              <td colSpan="5">No confirmed orders.</td>
            </tr>
          ) : (
            orders.map((order) =>
              order.order_items.length === 0 ? (
                <tr key={`empty-${order.id}`}>
                  <td colSpan="5">No items for this order.</td>
                </tr>
              ) : (
                order.order_items.map((item, index) => (
                  <tr key={`${order.id}-${item.id}`}>
                    <td>{index + 1}</td>
                    <td>{item.item_name}</td>
                    <td>{item.quantity}</td>
                    <td>
                      {item.created_on
                        ? `${formatDistanceToNow(
                            new Date(item.created_on)
                          )} ago`
                        : "N/A"}
                    </td>
                    <td className="Actionsss">
                      <button onClick={() => handleEditItem(item)}>
                        <EditIcon />
                      </button>
                      <button
                        onClick={() => deleteOrderItem(item.id, order.id)}
                      >
                        <DeleteIcon />
                      </button>
                    </td>
                  </tr>
                ))
              )
            )
          )}
        </tbody>
      </table>

      {/* Order item edit dialog */}
      {editingItem && (
        <OrderItemEdit
          openDialog={Boolean(editingItem)}
          editingItem={editingItem}
          setEditingItem={setEditingItem}
        />
      )}
    </div>
  );
}

export default OrderConfirm;
